import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {updateRevenueTableSetting} from "../../../../../api/main/SalesApi";

export const useUpdateRevenueTableSetting = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: { isHidden: string, revenueViewInfoId: number }[]) => updateRevenueTableSetting(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "수정되었습니다.",
                type: "alert",
                closeAction: () => {
                    qc.invalidateQueries({queryKey: ["readYearlyRevenue"]});
                    qc.invalidateQueries({queryKey: ["readRevenueByCompany"]});
                    qc.invalidateQueries({queryKey: ["readRevenueTableSetting"]});
                }
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
